// src/features/services/components/ServiceDetailsSection.tsx
import type { Service } from './ServiceRow';

interface ServiceDetailsSectionProps {
  service: Service;
}

const PLACEHOLDER_TEXT = 'پس از یکپارچه‌سازی با Core Services در دسترس خواهد بود.';

interface FieldRowProps {
  label: string;
  value: string;
  isPlaceholder?: boolean;
}

function FieldRow({ label, value, isPlaceholder = false }: FieldRowProps) {
  return (
    <div className="flex items-center justify-between gap-3 py-1.5">
      <span className="text-[11px] font-normal text-[var(--vania-colors-text-secondary,#a3aab8)]">{label}</span>
      <span
        className={
          isPlaceholder
            ? 'text-xs font-normal text-[var(--vania-colors-text-secondary,#a3aab8)]'
            : 'text-xs font-normal text-[var(--vania-colors-text-primary,#f5f6fa)]'
        }
      >
        {value}
      </span>
    </div>
  );
}

/**
 * Service details section. `expiresAt` is the only one of these four
 * fields that exists on `Service` today — type, start date, and
 * duration have no data source yet and render as safe placeholders
 * rather than invented values.
 */
export function ServiceDetailsSection({ service }: ServiceDetailsSectionProps) {
  return (
    <div>
      <FieldRow label="نوع سرویس" value={PLACEHOLDER_TEXT} isPlaceholder />
      <FieldRow label="تاریخ شروع" value={PLACEHOLDER_TEXT} isPlaceholder />
      <FieldRow label="تاریخ انقضا" value={service.expiresAt} />
      <FieldRow label="مدت زمان" value={PLACEHOLDER_TEXT} isPlaceholder />
    </div>
  );
}
